import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ConversionList from './ConversionList';
import { actions } from './ConversionList.actions';
import {
    mainSelector,
    getHeaderName,
    getTotalPages,
    getTotalItems
} from './ConversionList.selectors';
import {
    getConversionStatuses,
    getActionTypes,
    getActionNames
} from '../../../../selectors/index';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderName,
    list: mainSelector,
    statuses: getConversionStatuses,
    actionTypes: getActionTypes,
    actionNames: getActionNames,
    totalPages: getTotalPages,
    totalItems: getTotalItems
});

const ConversionListComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            page: state.conversions.page,
            totalPages: state.conversionsTotal.totalPages,
            totalItems: state.conversionsTotal.totalItems,
            loading: state.conversionsTotal.loading
        };
    },
    null
)(ConversionList);

export default ConversionListComponent;
